import {Routes} from '@angular/router';
import {LandingComponent} from './pages/landing/landing.component';
import {NoPageFoundComponent} from './pages/no-page-found/no-page-found.component';
import {ImprintComponent} from './pages/imprint/imprint.component';
import {ContactComponent} from './pages/contact/contact.component';
import {PrivacyComponent} from './pages/privacy/privacy.component';

export const routes: Routes = [
    {
        path: '',
        component: LandingComponent,
    },
    {
        path: 'kontakt',
        component: ContactComponent,
    },
    {
        path: 'rechtliches/impressum',
        component: ImprintComponent,
    },
    {
        path: 'rechtliches/datenschutz',
        component: PrivacyComponent,
    },
    {
        path: 'datenschutz',
        redirectTo: '/rechtliches/datenschutz',
    },
    {
        path: '**',
        component: NoPageFoundComponent,
    },
];
